import moment from 'moment'

export function buildLiveRange() {
    return {
        start: moment().subtract(4, "hours").startOf("hour").format('YYYY-MM-DD HH:mm:ss'),
        end: moment().format('YYYY-MM-DD HH:mm:ss')
    }
}